import React, { useState } from 'react';
import { motion } from 'framer-motion';

import kuchikuKuchiku from '../assets/Released/kuchiku-kuchiku.jpeg';
import mandoPlus from '../assets/Released/mando-plus.jpeg';
import aa from '../assets/Released/aa.jpeg';

// const videos = [
//   {
//     id: 1,
//     title: 'Rise of the Golden Throne — Official Trailer',
//     thumb: '/images/hero1.jpg',
//     duration: '2:34',
//     views: '4.2M',
//     youtubeId: 'dQw4w9WgXcQ',
//     featured: true,
//   },
//   {
//     id: 2,
//     title: 'The Last Fortress — Teaser Trailer',
//     thumb: '/images/hero4.jpg',
//     duration: '1:58',
//     views: '2.8M',
//     youtubeId: 'dQw4w9WgXcQ',
//     featured: false,
//   },
//   {
//     id: 3,
//     title: 'Magic Moon Studios — 2024 Showreel',
//     thumb: '/images/hero2.jpg',
//     duration: '3:12',
//     views: '6.1M',
//     youtubeId: 'dQw4w9WgXcQ',
//     featured: false,
//   },
//   {
//     id: 4,
//     title: 'Beyond the Orange Horizon — Full Trailer',
//     thumb: '/images/hero3.jpg',
//     duration: '2:47',
//     views: '1.9M',
//     youtubeId: 'dQw4w9WgXcQ',
//     featured: false,
//   },
// ];

const videos = [
  {
    id: 1,
    title: 'Kuchiku Kuchiku — Official Trailer',
    thumb: kuchikuKuchiku,
    youtubeId: '3-SyM_cSbok',
    featured: true,
  },
  {
    id: 2,
    title: 'Mando Plus — Official Trailer',
    thumb: mandoPlus,
    youtubeId: 'eAu0ORAJdcw',
    featured: false,
  },
  {
    id: 3,
    title: 'Unde Nama — Official Trailer',
    thumb: aa,
    youtubeId: 'nNW9eCwS2Dk',
    featured: false,
  },
];

function PlayIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <polygon points="5,3 19,12 5,21" fill="white" />
    </svg>
  );
}

function VideoModal({ video, onClose }) {
  if (!video) return null;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: 'spring', damping: 25 }}
        className="relative w-full max-w-4xl aspect-video bg-black rounded-sm overflow-hidden border border-brand-gold/20"
        onClick={(e) => e.stopPropagation()}
      >
        <iframe
          src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1`}
          title={video.title}
          allow="autoplay; fullscreen"
          className="w-full h-full"
          frameBorder="0"
          allowFullScreen
        />
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 bg-brand-orange rounded-full flex items-center justify-center text-white font-bold text-lg hover:bg-brand-gold transition-colors"
        >
          x
        </button>
      </motion.div>
    </motion.div>
  );
}

export default function Videos() {
  const [activeVideo, setActiveVideo] = useState(null);
  const featured = videos.find((v) => v.featured);
  const thumbs = videos.filter((v) => !v.featured);

  return (
    <section id="videos" className="relative py-24 bg-brand-black diagonal-lines-bg overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-orange/30 to-transparent" />

      {/* Glow blobs */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-orange/4 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <span className="section-label block mb-4">Watch & Experience</span>
          <h2 className="font-cinzel font-black text-4xl md:text-5xl text-white mb-5">
            Our <span className="text-gold-gradient">Cinematic</span> Reel
          </h2>
          <div className="gold-divider mb-6" />
          <p className="font-inter text-white/50 max-w-xl mx-auto text-sm leading-relaxed">
            Witness the power of storytelling through our trailers, teasers and
            behind-the-scenes content that define Magic Moon's signature style.
          </p>
        </motion.div>

        {/* Featured video */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative mb-8 group cursor-pointer rounded-sm overflow-hidden"
          style={{ aspectRatio: '16/7' }}
          onClick={() => setActiveVideo(featured)}
        >
          <img
            src={featured.thumb}
            alt={featured.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            style={{ filter: 'brightness(0.45)' }}
          />

          {/* Gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-brand-black/80 via-transparent to-transparent" />
          <div className="absolute inset-0 border border-brand-gold/10 group-hover:border-brand-orange/50 transition-colors duration-400" />

          {/* Corner accents */}
          <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-brand-gold/60 transition-all duration-400 group-hover:w-20 group-hover:h-20" />
          <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-brand-gold/60 transition-all duration-400 group-hover:w-20 group-hover:h-20" />

          {/* Play button */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <motion.div
              whileHover={{ scale: 1.15 }}
              className="w-20 h-20 rounded-full flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, #f37021, #D4AF37)',
                boxShadow: '0 0 40px rgba(243,112,33,0.6)',
              }}
            >
              <PlayIcon size={28} />
            </motion.div>
          </div>

          {/* Info */}
          <div className="absolute bottom-0 left-0 right-0 p-8">
            <div className="flex items-center gap-3 mb-2">
              <span className="section-label">Featured</span>
            </div>
            <h3 className="font-cinzel font-bold text-white text-xl md:text-2xl">
              {featured.title}
            </h3>
          </div>
        </motion.div>

        {/* Thumbnail row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {thumbs.map((v, i) => (
            <motion.div
              key={v.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="video-thumb cursor-pointer h-48"
              onClick={() => setActiveVideo(v)}
            >
              <img src={v.thumb} alt={v.title} style={{ filter: 'brightness(0.4)' }} />

              <div className="play-btn">
                <PlayIcon size={18} />
              </div>

              {/* Title overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/90 to-transparent">
                <p className="font-cinzel text-xs text-white/80 leading-tight">{v.title}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Video modal */}
      {activeVideo && (
        <VideoModal video={activeVideo} onClose={() => setActiveVideo(null)} />
      )}
    </section>
  );
}
